import reactUseMeasure from "react-use-measure";
import { ResizeObserver } from "@juggle/resize-observer";

const useMeasure = () => reactUseMeasure({ polyfill: ResizeObserver });

export default useMeasure;
